const hyphenate = (s: string) =>
  s
    .replace(/[A-Z]|^ms/g, '-$&')
    .replace('_', '--') // to handle modifiers for non-root rules (aka subelements)
    .toLowerCase()

const isVariant = (key: string) => RegExp(/^_/).test(key)
const isParent = (key: string) => RegExp(/^\^/).test(key)

const createGenerateId =
  (elementName: string, prefix = '') =>
  (rule: any) => {
    const baseId = `${prefix}ds-${elementName.toLowerCase().replace('_', '--')}`
    if (rule.key === 'root') {
      return baseId
    }
    if (isParent(rule.key)) {
      const [parent, ...modifiers] = rule.key.slice(1).split('_')
      if (modifiers.length === 0) {
        return `ds-${parent}`
      }
      return modifiers.map((m: string) => `ds-${parent}--${m}`).join('.')
    }
    return baseId + (isVariant(rule.key) ? `--${hyphenate(rule.key.slice(1))}` : `-${hyphenate(rule.key)}`)
  }

export default createGenerateId
